<template>
    <div>
        <template v-if="[
            'jetton:burn',
            'jetton:burn_notification',
            'jetton:transfer',
            'jetton:transfer_notification',
            'jetton:internal_transfer',
            'jetton:swap',
            'jetton:route_tonapi',
        ].includes(action.type)">
            <!-- A failed swap keeps its signs, so the two legs can be
                 told apart, but is drawn in the muted text colour: -->
            <div v-if="action.type === 'jetton:swap'" class="mobile-swap"
                v-bind:class="is_failed ? 'muted' : 'mobile-swap--red'">
                <span v-if="meta.jetton_in_address !== null" class="ui-inline-jetton__link"
                    v-bind:class="{ 'ui-inline-jetton--red': !is_failed }"
                    v-bind:to="{ name: 'token', params: { address: meta.jetton_in_address }}">
                    <ui-inline-jetton
                        v-bind:isOut="true"
                        v-bind:address="meta.jetton_in_address"
                        v-bind:value="meta.amount_in"
                        v-bind:symbol="meta.jetton_in_address === 'EQCM3B12QK1e4yZSf8GtBRT0aLMNyEsBc_DhVfRRtOEffLez' ? 'GRAM' : (meta.symbol_in || meta.jetton_in_address)"
                        v-bind:decimals="meta.decimals_in"
                        v-bind:hide-color="is_failed"
                        show-sign
                    />
                </span>
                <span v-else>
                    &minus;{{$ton(meta.amount_in, meta.decimals_in, true)}} GRAM
                </span>
            </div>

            <ui-inline-jetton v-else
                v-bind:isOut="is_out"
                v-bind:address="meta.jetton_address"
                v-bind:value="action.amount"
                v-bind:symbol="meta?.symbol || meta?.jetton_address"
                v-bind:decimals="meta.decimals"
                v-bind="meta.jetton"
                v-bind:show-sign="event !== 'jvault_unstake_request' && !is_failed"
                v-bind:hide-color="is_failed"
                v-bind:class="{'muted': event === 'jvault_unstake_request' || is_failed}"
            />
        </template>

        <!-- NFT transfer: -->
        <!--<ui-inline-nft-item-->
        <!--    v-else-if="action.type === 'nft:transfer_action'"-->
        <!--    v-bind:address="action.nft"-->
        <!--    v-bind:event-type="event"-->
        <!--    v-bind:image-src="meta.image"-->
        <!--    v-bind:nft-name="meta.name"-->
        <!--    v-bind:collection-name="meta.collection"-->
        <!--/>-->

        <!-- dex liquidity actions: -->
        <template v-else-if="action.type.startsWith('dex:')">
            <ui-inline-jetton
                v-bind:isOut="is_out"
                v-bind:address="meta.jetton_address"
                v-bind:value="meta.amount"
                v-bind:symbol="meta?.symbol || meta?.jetton_address"
                v-bind:decimals="meta.decimals"
                v-bind:show-sign="!is_failed"
                v-bind:hide-color="is_failed"
                v-bind:class="{'muted': is_failed}"
            />
        </template>

        <!-- nominator pool actions: -->
        <template
            v-else-if="action.type.startsWith('pool:')">
            <template v-if="action.type === 'pool:new_stake_ok'">
                <span class="tx-row-msg-action tx-row-msg-action--single">
                    Stake accepted
                </span>
            </template>

            <template v-else>
                {{$ton(amount, undefined, true)}} GRAM
            </template>
        </template>

        <span v-else-if="event === 'teleitem_start_auction'">
            {{$ton(amount)}} GRAM
        </span>

        <span v-else class="muted">
            {{$ton(amount)}} GRAM
        </span>
    </div>
</template>

<script>
import UiInlineJetton from './TxRowInlineJetton.vue';

export default {
    props: {
        action: Object,
        amount: String,
        is_out: Boolean,
        is_failed: Boolean,
        meta: {
            type: Object,
            default: () => ({}),
        },
        from: String,
        to: String,
        event: String,
    },
    components: {
        UiInlineJetton,
    },
};
</script>

<style lang="scss">
.mobile-swap {
    text-transform: uppercase;

    &--green {
        color: var(--badge-green-color);
    }
    &--red {
        color: var(--badge-red-color);
    }
}
</style>
